export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-contour/src/constant.js
// module id = 130
// module chunks = 0